import { useContext } from "react";
import { AlertContext } from "../../../app/AlertProvider";
import { PrimaryButton } from "../ButtonPrimary";
import { SecundaryButton } from "../ButtonSecundary";
import { Modal } from "../Modal";
import Spinner from "../Spinner/Spinner";

const AlertModal = () => {
  const { content, hideAlert, show, actions, isLoading, setLoading } = useContext(AlertContext);

  const handleClose = () => {
    hideAlert();
    actions?.onClose?.();
  };

  const handleAccept = async () => {
    setLoading(true);
    try {
      await actions?.onAccept?.();
      hideAlert();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    hideAlert();
    actions?.onCancel?.();
  };

  return (
    <Modal show={show} onClose={handleClose}>
      <div className="max-w-sm mx-auto">
        <div className="flex justify-center w-full">
          {content?.icon ? (
            content.icon
          ) : (
            <svg
              width="44"
              height="41"
              viewBox="0 0 44 41"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.1809 34.7642C23.1136 34.7642 23.8696 34.0081 23.8696 33.0754C23.8696 32.1428 23.1136 31.3867 22.1809 31.3867C21.2483 31.3867 20.4922 32.1428 20.4922 33.0754C20.4922 34.0081 21.2483 34.7642 22.1809 34.7642Z"
                fill="#DD6E6B"
              />
              <path
                d="M22.176 28.6921C21.8392 28.6921 21.5163 28.5583 21.2781 28.3202C21.04 28.0821 20.9062 27.7591 20.9062 27.4224V12.1857C20.9062 11.849 21.04 11.526 21.2781 11.2879C21.5163 11.0498 21.8392 10.916 22.176 10.916C22.5127 10.916 22.8357 11.0498 23.0738 11.2879C23.3119 11.526 23.4457 11.849 23.4457 12.1857V27.4224C23.4457 27.7591 23.3119 28.0821 23.0738 28.3202C22.8357 28.5583 22.5127 28.6921 22.176 28.6921Z"
                fill="#DD6E6B"
              />
              <path
                d="M18.4477 2.12035C18.8006 1.47808 19.3196 0.94242 19.9504 0.56941C20.5812 0.1964 21.3006 -0.000259294 22.0335 2.56584e-07C22.7663 0.000259808 23.4856 0.197429 24.1162 0.570886C24.7467 0.944342 25.2653 1.48037 25.6178 2.12289L43.2542 34.5769C43.5924 35.1996 43.763 35.8995 43.7492 36.608C43.7355 37.3165 43.5378 38.0092 43.1756 38.6183C42.8133 39.2273 42.2991 39.7318 41.6831 40.0822C41.0672 40.4326 40.3708 40.6169 39.6621 40.617H4.42996C3.71337 40.633 3.00515 40.4604 2.37632 40.1164C1.74749 39.7724 1.22014 39.2691 0.847158 38.657C0.474172 38.0449 0.268655 37.3456 0.251211 36.629C0.233768 35.9124 0.405011 35.2039 0.747772 34.5744L18.4477 2.12035ZM2.97994 35.7895C2.84912 36.03 2.78437 36.3009 2.7923 36.5745C2.80023 36.8482 2.88054 37.1149 3.02506 37.3474C3.16959 37.5799 3.37315 37.77 3.61503 37.8983C3.85691 38.0265 4.12846 38.0884 4.40202 38.0775H39.6621C39.9306 38.0774 40.1945 38.0074 40.4278 37.8746C40.6612 37.7417 40.8559 37.5504 40.9931 37.3196C41.1302 37.0887 41.205 36.8262 41.21 36.5577C41.2151 36.2893 41.1503 36.0241 41.022 35.7882L23.3894 3.34055C23.2558 3.09776 23.0594 2.89526 22.8208 2.75419C22.5823 2.61311 22.3102 2.53863 22.0331 2.5385C21.7559 2.53837 21.4838 2.6126 21.2451 2.75345C21.0064 2.8943 20.8099 3.09661 20.676 3.33929L2.97867 35.7895H2.97994Z"
                fill="#DD6E6B"
              />
            </svg>
          )}
        </div>
        <h1 className="w-full mt-5 text-xl font-bold text-center">
          {content?.title}
        </h1>
        {content?.subtitle && (
          <p className="mt-5 font-normal text-center text-lav-black-text">
            {content?.subtitle}
          </p>
        )}
        <div className="flex mb-6 mt-9">
          {content?.showCancelButton && (
            <SecundaryButton
              type="button"
              text={content.cancelButtonText || "Cancelar"}
              onClick={handleCancel}
              styles="font-bold mr-3 text-lav-black-text border-none"
            />
          )}
          <div className="relative flex-1">
            <PrimaryButton
              type="button"
              disabled={isLoading}
              text={content?.acceptButtonText || "Aceptar"}
              styles="bg-red-400 text-white font-bold hover:bg-opacity-80 w-full"
              onClick={handleAccept}
            />
            {isLoading && (
              <div className="absolute inset-0 flex items-center justify-center bg-red-400 rounded-lg">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AlertModal;
